import type { VideoReference } from '@/api/types';

/** Потолок своего названия закладки — тот же, что проверяет бэкенд (BookmarkController::TITLE_MAX). */
export const SAVED_TITLE_MAX = 120;

type TitledVideo = Pick<VideoReference, 'title' | 'saved_title'>;

/** Что показать на карточке Saved: своё название закладки, иначе название видео. */
export function savedDisplayTitle(video: TitledVideo): string {
  return video.saved_title || video.title;
}

/**
 * Что отправить после правки названия в Saved: строка — своё название, null — вернуть
 * название видео (пусто или совпало с ним), undefined — ничего не поменялось, запрос не нужен.
 */
export function savedTitlePatch(draft: string, video: TitledVideo): string | null | undefined {
  const trimmed = draft.trim().slice(0, SAVED_TITLE_MAX);
  const next = trimmed === '' || trimmed === video.title ? null : trimmed;
  return next === (video.saved_title || null) ? undefined : next;
}
